import AbstractSocket, { type AbstractSocketEvents, type SocketState } from './AbstractSocket';

export default class NullSocket<E extends AbstractSocketEvents> extends AbstractSocket<unknown, E> {
  connect(): void {}

  close(): void {}

  send(): void {}

  get debugLabel(): string {
    return 'NullSocket';
  }

  get state(): SocketState {
    return 'closed';
  }

  protected flushQueuedMessages(): void {}

  protected clearQueuedMessages(): void {}
}
